import React from 'react'
import '../styles/contact.css'
import {HiOutlineMail} from 'react-icons/hi';
import {BsWhatsapp} from 'react-icons/bs';
import {BsLinkedin} from 'react-icons/bs';
import { useRef } from 'react';
import emailjs from 'emailjs-com';


const Contact = () => {
  const service_id = process.env.REACT_APP_SERVICE_ID;
  const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID;
  const User_Id = process.env.REACT_APP_USER_ID;
  const form = useRef();
  const sendEmail = (e) => {
    const btn = document.querySelector('button[type]');
    btn.innerHTML = "Sending....";
    e.preventDefault();

    emailjs.sendForm(service_id, TEMPLATE_ID, form.current, User_Id)
      .then((result) => {
          // console.log(result.text);
          setTimeout((()=>{btn.innerHTML = "Message Sent";
        btn.style.backgroundColor = '#76FF03';
        e.target.reset();
      }),1500);
          setTimeout((()=>{btn.innerHTML = "Send Message";
        btn.style.backgroundColor = '#4db5ff'}),2500);
          
      }, (error) => {
          console.log(error.text);
      });

  };

  return (
    <section id='contact'>
      <h5>Get In Touch Below</h5>
      <h2>Contact Me</h2>
      <div className="contact_container">
        <div className="contact_cards_container">
          <div className='contact_card'>
            <HiOutlineMail className='contact_icon'/>
            <h4>Email</h4>
            <a href="mailto:svnitnavare@gmail.com" target='_blank'>Send Message</a>
          </div>
          <div className='contact_card'>
            <BsLinkedin className='contact_icon'/>
            <h4>LinkedIn</h4>
            <a href="https://www.linkedin.com/in/somesh-nitnavare/" target='_blank'>Send Message</a>
          </div>
          <div className='contact_card'>
            <BsWhatsapp className='contact_icon'/>
            <h4>Whatsapp</h4>
            <a href="https://api.whatsapp.com/send?phone=+918793826140" target='_blank'>Send Message</a>
          </div>
        </div>
        <form ref={form} onSubmit={sendEmail} className="form">
          <input type="text" name="name" id="name" placeholder='Your Full Name' required/>
          <input type="email" name="email" id="email" placeholder='Your Email' />
          <textarea name="message" id="message"  rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary' >Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact;